import React from "react";
import EditAnimalCampaignForm from "./EditAnimalCampaignForm";
// import EditProductCampaignForm from "./EditProductCampaignForm"; // Commented out - shop feature disabled
import EditCapitalCampaignForm from "./EditCapitalCampaignForm";
import classes from "./EditCampaign.module.css";
import { Grid, Card, CardMedia, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, useSortable, arrayMove, rectSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// This is the modal to open up the 3 different edit campaign forms

// TODO:
// Refactor the code to send common props
// Change the Edit Animal campaign page (refactor)

const maxSize = 10 * 1024 * 1024;

function SortableItem({ id, value, width, onDelete, itemIndex, disabled }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id, disabled });
  const style = { transform: CSS.Transform.toString(transform), transition };
  return (
    <Grid size={width > 900 ? 4 : width > 530 ? 5 : 8} className="relative" ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Card className="relative">
        <CardMedia
          component="img"
          sx={{ height: 110, objectFit: "cover" }}
          src={value}
          alt="campaign image"
          style={{ cursor: disabled ? "default" : "grab" }}
        />
        {!disabled && (
          <IconButton
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => { e.stopPropagation(); onDelete(itemIndex); }}
            sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'rgba(255,255,255,0.8)', '&:hover': { bgcolor: 'rgba(255,255,255,0.95)' } }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Card>
    </Grid>
  );
}

function SortableList({ items, width, onDelete, disabled, onSortEnd }) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragEnd = ({ active, over }) => {
    if (over && active.id !== over.id) {
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);
      onSortEnd({ oldIndex, newIndex });
    }
  };

  // items prop is campaignData.image_urls which only contains the URLs of pics
  // everytime an image is sorted or uploaded, it sorts campaignData.image_urls
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={items} strategy={rectSortingStrategy}>
        <div className="max-[900px]:ml-20">
          <Grid container spacing={2} className="overflow-auto">
            {items.map((value, index) => (
              <SortableItem
                key={value}
                id={value}
                value={value}
                itemIndex={index}
                width={width}
                onDelete={onDelete}
                disabled={disabled}
              />
            ))}
          </Grid>
        </div>
      </SortableContext>
    </DndContext>
  );
}

// Modal component
const EditCampaignModal = ({ campaignId, campaignData, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-70 w-full h-full flex items-baseline justify-center overflow-auto p-4 sm:p-12 z-50`}
    >
      <div
        className={`${classes.campaign_modal} relative bg-white rounded w-full sm:w-4/5 flex flex-col items-center border-box h-auto p-5`}
      >
        <button
          onClick={onClose}
          className={`absolute mr-4 max-w-4 top-2 right-2 p-2 border-none text-2xl cursor-pointer zinc-800 bg-transparent`}
        >
          x
        </button>
        <h2 className={`text-3xl font-bold text-orange text-center mb-4 `}>
          Campaign Details
        </h2>
        {campaignData.campaign_type === "animal" ? (
          <EditAnimalCampaignForm
            campaignId={campaignId}
            campaignInfo={campaignData}
            maxSize={maxSize}
            SortableItem={SortableItem}
            SortableList={SortableList}
            onClose={onClose}
          />
        ) : /* Product campaign form commented out - shop feature disabled
        campaignData.campaign_type === "product" ? (
          <EditProductCampaignForm
            campaignId={campaignId}
            campaignData={campaignData}
            maxSize={maxSize}
            SortableItem={SortableItem}
            SortableList={SortableList}
            onClose={onClose}
          />
        ) : */ campaignData.campaign_type === "capital" ? (
          <EditCapitalCampaignForm
            campaignId={campaignId}
            campaignData={campaignData}
            onClose={onClose}
          />
        ) : null}
      </div>
    </div>
  );
};

export default EditCampaignModal;
